import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { Link } from "react-router-dom";
import { URLS } from "../../../services/urls.ts";

const UploadSuccessDialog = ({ fileId, jobId, onClose, teamId }) => {
  const [open, setOpen] = useState(true); // Automatically open the dialog

  const handleClose = () => {
    setOpen(false);
    onClose(); // Call the onClose prop to notify parent component
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Processing Started</DialogTitle>
      <DialogContent>
        <DialogContentText>
          This file has been assigned the ID: <Link to={URLS.teamReportDetail(teamId, fileId)}><strong>{fileId}</strong></Link>.
        </DialogContentText>
        <DialogContentText>
          Depending on extractions used and the size of the file, extractions
          can take up to 3 minutes to complete.
        </DialogContentText>
        <DialogContentText>
          You can track the upload status using the job ID:{" "}
          <Link to={URLS.teamJobDetail(teamId, fileId, jobId)}>
            <strong>{jobId}</strong>
          </Link>{" "}
          here.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Link to={URLS.teamReports(teamId, fileId)}>
          <Button variant="contained" autoFocus>
            Continue to Post List
          </Button>
        </Link>
      </DialogActions>
    </Dialog>
  );
};

export default UploadSuccessDialog;
